/**
 * Created by lihanying on 2017/7/6.
 */
import { GETCLUBEXPENDLIST, GETPERIOD } from './constants'

const initState = {}

export default function (state = initState, action) {
  switch (action.type) {
    case GETCLUBEXPENDLIST:
      return Object.assign({}, state, { expendList: action.payload })

    case GETPERIOD:
      return Object.assign({}, state, { period: action.payload })


    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/ClubExpend/reduce.js